import { render, staticRenderFns } from "./LinkedContactListItem.vue?vue&type=template&id=45f2a1fc"
import script from "./LinkedContactListItem.vue?vue&type=script&lang=js"
export * from "./LinkedContactListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports